<template>
  <Sidebar :initValue="initValue" :title="editedEntity.title || 'create routine'" :saveButton="true" @close="$emit('close')" @enterClick="$root.$emit('routineSidebarFooterSaveClicked')">

    <div v-if="edit">
      <RoutineSidebarEdit :key="`routine-sidebar-1-${editedEntity.id}`" :editedEntity="editedEntity" @saved="$emit('close')">
        <Detail :routine="editedEntity" :key="`${editedEntity.id}-detail-routine`"/>
      </RoutineSidebarEdit>

      </div>
      <div v-else>
        <div class="flex justify-around mt-4 ">
          <FilterOptions v-model="filter" :filterOptions="filterOptions"/>
        </div>

       <keep-alive v-if="custom">
        <RoutineSidebarEdit :key="`routine-sidebar-2-${editedEntity.id}`" :editedEntity="localEntity" @saved="$emit('close')"/>
      </keep-alive>

      <keep-alive v-if="getInspired">
        <Templates @inpiredBy="inpiredBy"/>
      </keep-alive>

      </div>

      <template v-if="showFooter" v-slot:sidebar-footer>
          <vs-button color="dark" class="px-20" @click="$root.$emit('routineSidebarFooterSaveClicked')">save</vs-button>

          <!-- <vs-button class="ml-2" color="success" type="flat" @click="$root.$emit('routineSidebarFooterSaveClicked')">accomplished</vs-button> -->
     </template>

    </Sidebar>


</template>
<script>
import RoutineSidebarEdit from './RoutineSidebarEdit'
import Templates from './Templates'
import Detail from './Detail'
import trackAnalytics from '@/helpers/trackAnalytics'
import Sidebar from '@/views/Self-Improvee/Generic/Sidebar'
import _ from 'lodash'

export default {
  components: {
    RoutineSidebarEdit,
    Detail,
    Templates,
    Sidebar
  },
  props: ['editedEntity', 'showSection', 'initValue'],
  watch: {
    'editedEntity': {
      immediate: true,
      async handler (editedEntity) {
        this.localEntity = editedEntity
      }
    },
    'showSection': {
      immediate: true,
      async handler (showSection) {
        if (showSection === 'get inspired') {
          this.filter = 'get inspired'
        } else {
          this.filter = 'new routine'
        }
      }
    }
  },
  data () {
    return {
      filter: ['new routine'],
      filterOptions: ['new routine', 'get inspired'],
      localEntity: {}
    }
  },
  computed: {
    showFooter () {
      return this.custom || this.edit
    },
    custom () {
      return _.includes(this.filter, 'new routine')
    },
    getInspired () {
      return _.includes(this.filter, 'get inspired')
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
  },
  methods: {
    inpiredBy (entity) {
      this.localEntity = entity
      this.filter = 'new routine'
      trackAnalytics(this, 'app_action', 'get inspired - routine')
    }
  }
}
</script>
<style>
</style>
